import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/flightDataUpload/index'

export const Route = createFileRoute(
  '/flightDataUpload/(deprecated_routes)/$siteID'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: params.siteID,
      }),
      replace: true,
    })
  },
})
